import React, { useRef, useEffect } from 'react';
import StatusPriority from './StatusPriority';
import CardMetaInfo from './CardMetaInfo';
import {
    HeaderSection,
    Title,
} from '../../styles/CardModal.styles';

const CardHeader = ({
    cardData,
    initialCard,
    allColumns,
    selectedStatus,
    selectedPriority,
    assignee,
    labels,
    showAssigneePicker,
    setShowAssigneePicker,
    setShowLabelPicker,
    handleStatusChange,
    handlePriorityChange,
    handleToggleLabel,
    saveCardChanges,
    setCardData,
    showStatusDropdown,
    setShowStatusDropdown,
    showPriorityDropdown,
    setShowPriorityDropdown,
    columnOrder,
    handleUnassign // Added handleUnassign prop
}) => {
    return (
        <HeaderSection>
            <Title
                value={cardData.title}
                onChange={e => {
                    setCardData(prev => ({ ...prev, title: e.target.value }));
                    const textarea = e.target;
                    textarea.style.height = 'auto';
                    textarea.style.height = `${textarea.scrollHeight}px`;
                }}
                onBlur={() => {
                    if (initialCard.title !== cardData.title) {
                        saveCardChanges(
                            { title: cardData.title },
                            { type: 'title', from: initialCard.title, to: cardData.title }
                        );
                    }
                }}
                placeholder="Card Title"
                rows={1}
                ref={ref => {
                    if (ref) {
                        ref.style.height = 'auto';
                        ref.style.height = `${ref.scrollHeight}px`;
                    }
                }}
            />

            <StatusPriority
                allColumns={allColumns}
                selectedStatus={selectedStatus}
                selectedPriority={selectedPriority}
                onStatusChange={handleStatusChange}
                onPriorityChange={handlePriorityChange}
                showStatusDropdown={showStatusDropdown}
                setShowStatusDropdown={setShowStatusDropdown}
                showPriorityDropdown={showPriorityDropdown}
                setShowPriorityDropdown={setShowPriorityDropdown}
                columnOrder={columnOrder}
            />

            <CardMetaInfo
                cardData={cardData}
                assignee={assignee}
                labels={labels}
                showAssigneePicker={showAssigneePicker}
                setShowAssigneePicker={setShowAssigneePicker}
                setShowLabelPicker={setShowLabelPicker}
                handleToggleLabel={handleToggleLabel}
                handleUnassign={handleUnassign} // Pass handleUnassign to CardMetaInfo
            />
        </HeaderSection>
    );
};

export default CardHeader;
